var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 31,
    viewBox: "0 0 124 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.81377 6.44434C2.81377 6.44434 -1.26722 14.2247 2.81377 24.0366C2.81377 24.0366 2.81377 24.0347 2.81483 24.0337V6.44434C2.81475 6.44434 2.81475 6.44434 2.81377 6.44434Z",
    fill: "url(#paint0_linear_539_3899)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81543 6.44434C2.81543 6.44434 6.89691 14.2247 2.81754 24.0366L2.81543 24.0337V6.44434Z",
    fill: "url(#paint1_radial_539_3899)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30032 3.10254C6.30032 3.10254 0.669413 13.8363 6.29756 27.3768C6.29756 27.3768 6.30032 27.373 6.30032 27.3713V3.10432V3.10254Z",
    fill: "url(#paint2_linear_539_3899)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2998 3.10254C6.2998 3.10254 11.9302 13.8363 6.30459 27.3768C6.30459 27.3768 6.30232 27.373 6.2998 27.3713V3.10432V3.10254Z",
    fill: "url(#paint3_radial_539_3899)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78777 1.55713C9.78777 1.55713 3.44055 13.6593 9.78452 28.9224C9.78452 28.9224 9.78541 28.9207 9.78777 28.917V1.559V1.55713Z",
    fill: "url(#paint4_linear_539_3899)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78906 1.55762C9.78906 1.55762 16.1357 13.6598 9.79166 28.9229C9.79166 28.9229 9.78906 28.9212 9.78906 28.9175V1.55948V1.55762Z",
    fill: "url(#paint5_radial_539_3899)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2752 1C13.2752 1 6.66881 13.5952 13.2714 29.4803C13.2714 29.4803 13.2729 29.4784 13.2752 29.4726V1.00089V1Z",
    fill: "url(#paint6_linear_539_3899)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2764 1C13.2764 1 19.8821 13.5952 13.2785 29.4803C13.2785 29.4803 13.2785 29.4784 13.2764 29.4726V1.00089V1Z",
    fill: "url(#paint7_radial_539_3899)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7633 1.55664C16.7633 1.55664 10.4152 13.6607 16.7616 28.9219C16.7616 28.9219 16.7633 28.9202 16.7633 28.9165V1.55851V1.55664Z",
    fill: "url(#paint8_linear_539_3899)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7617 1.55664C16.7617 1.55664 23.1115 13.6607 16.7654 28.9219C16.7654 28.9219 16.7654 28.9202 16.7617 28.9165V1.55851V1.55664Z",
    fill: "url(#paint9_radial_539_3899)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.249 3.10303C20.249 3.10303 14.6181 13.8368 20.248 27.3773C20.248 27.3773 20.249 27.3735 20.249 27.3718V3.10481V3.10303Z",
    fill: "url(#paint10_linear_539_3899)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.248 3.10303C20.248 3.10303 25.8803 13.8368 20.2517 27.3773C20.2517 27.3773 20.2507 27.3735 20.248 27.3718V3.10481V3.10303Z",
    fill: "url(#paint11_radial_539_3899)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7362 6.44434C23.7362 6.44434 19.6551 14.2247 23.7345 24.0356C23.7345 24.0356 23.7345 24.0345 23.7362 24.0339V6.44434Z",
    fill: "url(#paint12_linear_539_3899)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7354 6.44434C23.7354 6.44434 27.8175 14.2247 23.7381 24.0356L23.7354 24.0339V6.44434Z",
    fill: "url(#paint13_radial_539_3899)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32 8.30029H34.147V14.0211H36.3059V8.30029H38.4736V22.3298H36.3057V16.0499H34.147V22.3298H32V8.30029Z",
    fill: "#595A5C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6982 22.3299V8.30043L43.9023 8.29834V22.3299H41.6982Z",
    fill: "#595A5C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0674 22.3299V8.29834H49.2094V20.2987H52.5647V22.3299H47.0674Z",
    fill: "#595A5C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7744 22.3299V8.29834H57.8508C59.0413 8.29834 59.923 8.61334 60.4967 9.23532C61.0684 9.86688 61.3547 10.8392 61.3547 12.1497V18.4174C61.3547 19.7835 61.0783 20.7791 60.5393 21.4007C59.9961 22.0187 59.1341 22.3299 57.949 22.3299H54.7744V22.3299ZM56.9225 20.261H58.0157C58.3971 20.261 58.6818 20.1413 58.8638 19.9028C59.0487 19.6647 59.1428 19.2906 59.1428 18.7872V12.033C59.1428 11.4585 59.0001 11.0373 58.726 10.7684C58.4456 10.5028 58.0122 10.3652 57.4144 10.3652H56.9223L56.9225 20.261Z",
    fill: "#595A5C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8311 22.3299V8.29834H72.4761V10.325H68.9937V14.0048H71.505V16.0318H68.9937V20.2215H72.4761V22.329H66.8311V22.3299V22.3299Z",
    fill: "#595A5C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1387 22.3299V8.29834H77.0819L79.8203 16.6838C79.8752 16.8432 79.9422 17.0595 80.013 17.3194C80.0879 17.5864 80.1666 17.8725 80.2452 18.1755C80.17 17.7702 80.1133 17.3897 80.0678 17.0439C80.0224 16.6974 79.9973 16.4457 79.9973 16.2798V8.29834H82.0238V22.3299H79.9975L77.3595 14.5742C77.3468 14.5422 77.3344 14.4954 77.3102 14.4305C77.1283 13.8992 76.9951 13.4369 76.905 13.0509C76.9811 13.5449 77.0417 13.9538 77.082 14.2803C77.1234 14.6071 77.1493 14.8431 77.1493 14.9946V22.329H75.1387V22.3299V22.3299Z",
    fill: "#595A5C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2324 22.3299V8.29834H90.8764V10.325H87.3932V14.0048H89.9062V16.0318H87.3932V20.2215H90.8764V22.329H85.2324V22.3299Z",
    fill: "#595A5C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6833 16.4301V22.3299H93.5186V8.29834H96.6953C97.8839 8.29834 98.7458 8.61942 99.2752 9.25846C99.808 9.8961 100.07 10.9275 100.07 12.3539C100.07 13.2375 99.964 13.9461 99.7473 14.489C99.5368 15.0322 99.186 15.4731 98.7044 15.8077L100.292 22.3292H98.053L96.7128 16.4294H95.6835L95.6833 16.4301ZM95.6833 10.325V14.4013H96.5353C97.0372 14.4013 97.3811 14.2516 97.5759 13.9505C97.7707 13.6508 97.8695 13.0919 97.8695 12.2778C97.8695 11.5378 97.7648 11.0303 97.5646 10.7466C97.3595 10.4675 96.9918 10.3254 96.4626 10.3254H95.6833V10.325Z",
    fill: "#595A5C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M102.559 18.7291V11.5383C102.559 10.4335 102.861 9.56262 103.461 8.93993C104.062 8.31412 104.892 8 105.955 8C106.974 8 107.756 8.30264 108.283 8.91315C108.812 9.52053 109.08 10.4123 109.08 11.6006V12.8877H106.99V11.4018C106.99 10.916 106.899 10.5539 106.708 10.3137C106.524 10.0698 106.246 9.94753 105.878 9.94753C105.509 9.94753 105.233 10.0698 105.04 10.3137C104.851 10.5539 104.763 10.916 104.763 11.4018V19.2324C104.763 19.7203 104.851 20.0844 105.04 20.3284C105.233 20.5743 105.509 20.6966 105.878 20.6966C106.246 20.6966 106.524 20.5743 106.708 20.3284C106.9 20.0845 106.99 19.7203 106.99 19.2324V17.0419H105.681V15.2534H109.08V22.33H108.041L107.622 21.3581C107.38 21.7929 107.094 22.1116 106.76 22.3182C106.422 22.5271 106.016 22.6294 105.539 22.6294C104.571 22.6294 103.835 22.2992 103.325 21.6317C102.812 20.964 102.559 19.9962 102.559 18.7291Z",
    fill: "#595A5C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M110.723 8.29834H112.911L114.322 13.9091H114.456L115.796 8.29834H118L115.475 16.5061V22.3294H113.31V16.7679L110.723 8.29834Z",
    fill: "#595A5C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_539_3899",
    x1: 0.999998,
    y1: 15.2404,
    x2: 2.8148,
    y2: 15.2404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04C23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_539_3899",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.7227 15.2405) scale(6.25277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0054,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3363,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8743,
    stopColor: "#E0E1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADCDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_539_3899",
    x1: 3.79685,
    y1: 15.2397,
    x2: 6.30032,
    y2: 15.2397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04C23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_539_3899",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.55169 15.2397) scale(8.62777 8.62777)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0054,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3363,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8743,
    stopColor: "#E0E1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADCDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_539_3899",
    x1: 6.96579,
    y1: 15.2398,
    x2: 9.78774,
    y2: 15.2398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04C23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_539_3899",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.1998 15.2403) scale(9.72637 9.72637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0054,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3363,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8743,
    stopColor: "#E0E1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADCDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_539_3899",
    x1: 10.3379,
    y1: 15.2401,
    x2: 13.2752,
    y2: 15.2401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04C23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_539_3899",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.7446 15.2402) scale(10.1227 10.1227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0054,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3363,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8743,
    stopColor: "#E0E1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADCDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_539_3899",
    x1: 13.9414,
    y1: 15.2393,
    x2: 16.7633,
    y2: 15.2393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04C23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_539_3899",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1733 15.2393) scale(9.72642 9.72642)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0054,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3363,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8743,
    stopColor: "#E0E1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADCDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_539_3899",
    x1: 17.7461,
    y1: 15.2402,
    x2: 20.249,
    y2: 15.2402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04C23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_539_3899",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5002 15.2402) scale(8.62779 8.62778)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0054,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3363,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8743,
    stopColor: "#E0E1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADCDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_539_3899",
    x1: 21.9219,
    y1: 15.24,
    x2: 23.7362,
    y2: 15.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04C23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_539_3899",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6429 15.24) scale(6.25247)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0054,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3363,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8743,
    stopColor: "#E0E1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADCDD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.92af7d4a224e2b05bc83489a2b92e1cd.svg";
export { ForwardRef as ReactComponent };